<template>
  <div>
    <div class="parent parent-2">
      <v-card @click="openLink">
        <v-card-title class="info-title">
          <div class="text-center">
            {{ link.Title }}
          </div>
        </v-card-title>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["link", "index"],
  methods: {
  
    openLink() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}
</style>


